import axios from "axios";

export default {
  async all(params) {
    params['active'] = 'true';
    let result = await axios.get(
      `/api/v1/templates`,
      {
        params: params
      }
    );
    return result.data.data;
  },
}
